export default __webpack_public_path__ + "static/media/asc_gris.a4f83ad1.svg";